import {mapToLabels} from 'utils/common';

export const WL_SUBSCRIPTION_TYPE = {
    STARTER: 'STARTER',
    ADVANCED: 'ADVANCED',
    PREMIUM: 'PREMIUM',
    PROFESSIONAL: 'PROFESSIONAL',
};
export const WL_SUBSCRIPTION_TYPE_LABELS = {
    [WL_SUBSCRIPTION_TYPE.STARTER]: 'Starter',
    [WL_SUBSCRIPTION_TYPE.ADVANCED]: 'Advanced',
    [WL_SUBSCRIPTION_TYPE.PREMIUM]: 'Premium',
    [WL_SUBSCRIPTION_TYPE.PROFESSIONAL]: 'Professional',
};

export const WL_FUNCTIONALITY = {
    AUDIENCES: 'AUDIENCES',
    AUDIENCE_ANALYTICS: 'AUDIENCE_ANALYTICS',
    PIXELS: 'PIXELS',
    AD_SERVER: 'AD_SERVER',
    ATTRIBUTION_STRATEGY: 'ATTRIBUTION_STRATEGY',
    PROXY_DOMAIN: 'PROXY_DOMAIN',
    REACH_FORECAST: 'REACH_FORECAST',
};

export const WL_FUNCTIONALITY_LABELS = {
    [WL_FUNCTIONALITY.AUDIENCES]: 'Audiences',
    [WL_FUNCTIONALITY.AUDIENCE_ANALYTICS]: 'Audience Analytics',
    [WL_FUNCTIONALITY.PIXELS]: 'Pixels',
    [WL_FUNCTIONALITY.AD_SERVER]: 'AdServer',
    [WL_FUNCTIONALITY.ATTRIBUTION_STRATEGY]: 'Attribution Strategy',
    [WL_FUNCTIONALITY.PROXY_DOMAIN]: 'Proxy Domain',
    [WL_FUNCTIONALITY.REACH_FORECAST]: 'Reach Forecast',
};

export const WL_FUNCTIONALITY_OPTIONS = mapToLabels(WL_FUNCTIONALITY_LABELS);

export const CREATIVE_FILE_UPDATE_SOURCES = {
  ADMIN_PANEL: 'ADMIN_PANEL',
  API: 'API'
}

export const CREATIVE_FILE_UPDATE_LABELS = {
  [CREATIVE_FILE_UPDATE_SOURCES.ADMIN_PANEL]: 'Admin panel',
  [CREATIVE_FILE_UPDATE_SOURCES.API]: 'API',
}

export const CREATIVE_FILE_UPDATE_OPTIONS = mapToLabels(CREATIVE_FILE_UPDATE_LABELS);
